/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ApiClientEnum = 'Stellenanzeigen' | 'Ui' | 'Webservice' | 'Sega' | 'SebuBackend' | 'Preview' | 'SynchronizationTool' | 'WorkflowTool' | 'Amsterdam' | 'ResellerAdmin';

export const ApiClientEnum = {
    Stellenanzeigen: 'Stellenanzeigen' as ApiClientEnum,
    Ui: 'Ui' as ApiClientEnum,
    Webservice: 'Webservice' as ApiClientEnum,
    Sega: 'Sega' as ApiClientEnum,
    SebuBackend: 'SebuBackend' as ApiClientEnum,
    Preview: 'Preview' as ApiClientEnum,
    SynchronizationTool: 'SynchronizationTool' as ApiClientEnum,
    WorkflowTool: 'WorkflowTool' as ApiClientEnum,
    Amsterdam: 'Amsterdam' as ApiClientEnum,
    ResellerAdmin: 'ResellerAdmin' as ApiClientEnum
};

